module.exports = __webpack_public_path__ + "static/media/ArrowLeftBlue.46c31cf7.svg";